import styled from 'styled-components'

import ContainerBase from '@mui/material/Container'
import { Nullable } from '@src/Application/Types/Opt'
import { SIDEBAR_POSITION } from '@src/Core/Constants/PageConstants'

export const Container = styled(ContainerBase)`
    padding-top: 50px;
    padding-bottom: 50px;

    @media ${(props) => props.theme.query.min.tablet} {
        padding-top: 100px;
        padding-bottom: 100px;
    }
`

export const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    flex-direction: column-reverse;
    padding-right: 20px;
    padding-left: 20px;

    @media ${(props) => props.theme.query.min.tablet} {
        flex-direction: row;
        padding-right: 0;
        padding-left: 0;
    }
`

export const ContentWrapper = styled.div`
    max-width: 800px;
`

export const SideContainer = styled.div<{ $state: Nullable<string> }>`
    @media ${(props) => props.theme.query.min.tablet} {
        ${(props) =>
            props.$state === SIDEBAR_POSITION.FIXED &&
            `
            position: fixed;
            top: 120px;
        `}
        ${(props) =>
            props.$state === SIDEBAR_POSITION.BOTTOM &&
            `
            position: absolute;
            bottom: 0px;
        `}
    }
`

export const SideWrapper = styled.div`
    width: 100%;
    position: relative;
    margin-bottom: 30px;

    @media ${(props) => props.theme.query.min.tablet} {
        max-width: 270px;
        margin-left: 30px;
        margin-bottom: 0px;
    }
`

export const ProgressScroll = styled.div.attrs((props: { $progress: number }) => ({
    style: {
        width: `${props.$progress}%`,
    },
}))<{ $progress: number; $progressPosition: number }>`
    background-color: ${(props) => props.theme.color.a500};
    height: 6px;
    position: fixed;
    top: ${(props) => props.$progressPosition}px;
`
